export default __webpack_public_path__ + "static/media/tpc_empl.17cddf68.svg";